export default __webpack_public_path__ + "media/images/nav/login-b5e410cf96a0b26a3dad09fd60a73054.png";